import styled from "styled-components";

import DEFAULT from "../../../assets/images/empty-image.svg";
import VISA from "../../../assets/images/services/visa.svg";
import MASTERCARD from "../../../assets/images/services/mc.svg";
import UAH from "../../../assets/images/services/uah.svg";
import USD from "../../../assets/images/services/usd.svg";
import RUB from "../../../assets/images/services/rub.svg";
import CRYPTO from "../../../assets/images/services/crypto.svg";
import MSBANK from "../../../assets/images/services/microservicebank.svg";
import MSCASH from "../../../assets/images/services/microservicecash.svg";
import ADVC from "../../../assets/images/services/advcash.svg";
import UAPAY from "../../../assets/images/services/uapay.svg";
import SUMSUB from "../../../assets/images/services/sumsub.svg";
import HUOBI from "../../../assets/images/services/huobi.svg";
import DECTA from "../../../assets/images/services/decta.svg";
import ADG from "../../../assets/images/services/adgroup.svg";
import KUNA from "../../../assets/images/services/kuna.svg";
import WHITEBITE from "../../../assets/images/services/whitebit.svg";
import SPOYNT from "../../../assets/images/services/spoynt.svg";
import WEBMONEY from "../../../assets/images/services/webmoney.svg"
import PERFECTMONEY from "../../../assets/images/services/perfectmoney.svg"
import CURRENCYLAYER from "../../../assets/images/services/currencylayer.svg"

const icon = {
  tag: String
};

const changeImg = (icon) => {
  switch (icon) {
    case "UaPay" :
      return `
        background-image: url(${UAPAY});
      `;
    case "MsBank" :
      return `
        background-image: url(${MSBANK});
      `;
    case "MsCash" :
      return `
        background-image: url(${MSCASH});
      `;
    case "AdvCash" :
      return `
        background-image: url(${ADVC});
      `;
    case "Huobi" :
      return `
        background-image: url(${HUOBI});
      `;
    case "SumSub" :
      return `
        background-image: url(${SUMSUB});
      `;
    case "Decta" :
      return `
        background-image: url(${DECTA});
      `;
    case "AdGroup" :
      return `
        background-image: url(${ADG});
      `;
    case "Kuna" :
      return `
        background-image: url(${KUNA});
      `;
    case "WhiteBit" :
      return `
        background-image: url(${WHITEBITE});
      `;
    case "Spoynt" :
      return `
        background-image: url(${SPOYNT});
      `;
    case "Webmoney" :
      return `
        background-image: url(${WEBMONEY});
      `;
    case "PerfectMoney" :
      return `
        background-image: url(${PERFECTMONEY});
      `;
    case "CurrencyLayer" :
      return `
        background-image: url(${CURRENCYLAYER});
      `;
    case "OCT_MC1" :
      return `
        background-image: url(${MASTERCARD});
      `;
    case "OCT_VISA1" :
      return `
        background-image: url(${VISA});
      `;
    case "Hryvnia1" :
    case "Hryvnia2" :
    case "Hryvnia3" :
    case "Hryvnia4" :
    case "Hryvnia5" :
      return `
        background-image: url(${UAH});
      `;
    case "Dollar1" :
    case "Dollar2" :
    case "Dollar3" :
      return `
        background-image: url(${USD});
      `;
    case "Ruble1" :
    case "Ruble2" :
    case "Ruble3" :
      return `
        background-image: url(${RUB});
      `;
    case "Crypto1" :
    case "Crypto2" :
    case "Crypto3" :
      return `
        background-image: url(${CRYPTO});
      `;
    default :
      return `
        background-image: url(${DEFAULT});
      `;
  }
};

export const StyledConnectionWrapper = styled.div`
  width: 100%;
  height: 255px;
  padding: 20px;
  display: grid;
  grid-auto-columns: 1fr;
  grid-template-areas: 'status'
                       'serviceIcon'
                       'name';
  align-items: center;
  border: 1px solid #E5E5E5;
  border-radius: 5px;
  .connection__active {
    display: inline-grid;
    justify-content: end;
  }
  cursor: pointer;
`;

export const StyledConnectionLogo = styled("div", icon)`
  width: 155px;
  height: 115px;
  margin: 0 auto;
  ${({ icon }) => changeImg(icon)};
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  grid-area: serviceIcon;
`;

export const StyledConnectionStatusWrapper = styled.div`
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(229, 229, 229, 0.5);
  display: grid;
  grid-area: status;
  .connection__status-item {
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
`;

export const StyledConnectionStatus = styled.div`
  width: 50px;
  height: 20px;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: ${({ enable }) => enable === true ? "linear-gradient(40deg, #277661 -20%, #29DEAE 70%)" : "linear-gradient(40deg, #FF0000 30%, #FB4B6B 90%)"};
  border-radius: 30px;
`;

export const StyledConnectionName = styled.h4`
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  grid-area: name;
`;